module.exports = function(app) {
    app.service('careCostEstimator', ['sessionData', 'brand', function(sessionData, brand) {
        var btsGlobal = {config: {brand: brand.current}, appConfig: sessionData.appConfig};
        var showCCEEntryLink = false;

        // App Config Override/Suppression Rules
        function checkCCEAppConfigKey(key) {
            return  btsGlobal &&
                btsGlobal.appConfig &&
                btsGlobal.appConfig.LANDING &&
                btsGlobal.appConfig.LANDING[key] &&
                btsGlobal.appConfig.LANDING[key].booleanValue;
        }

        // Check if the given value is in the key's Override Value.
        function keyHasOverrideValue(key, value) {
            var overrideValue = btsGlobal &&
                btsGlobal.appConfig &&
                btsGlobal.appConfig.LANDING &&
                btsGlobal.appConfig.LANDING[key] ?
                btsGlobal.appConfig.LANDING[key].overrideValue : "";

            return overrideValue.split(',').indexOf(value) > -1;
        }

        function _shouldDisplay(selectedPlan, umi, clientNumber) {
            var userUMI = umi || "0";
            var userGroupNumber = selectedPlan.groupNumber || "0";
            var userClientNumber = clientNumber || "0";

            // Check SUPPRESS_CCE_LINK[_BY_UMI|GROUP|CLIENT] AppConfig Keys.
            if (checkCCEAppConfigKey("SUPPRESS_CCE_ENTRY_LINK_BY_UMI")
                    && keyHasOverrideValue("SUPPRESS_CCE_ENTRY_LINK_BY_UMI", userUMI)) {
                showCCEEntryLink = false;
            } else if (checkCCEAppConfigKey("SUPPRESS_CCE_ENTRY_LINK_BY_GROUP")
                    && keyHasOverrideValue("SUPPRESS_CCE_ENTRY_LINK_BY_GROUP", userGroupNumber)) {
                showCCEEntryLink = false;
            } else if (checkCCEAppConfigKey("SUPPRESS_CCE_ENTRY_LINK_BY_CLIENT")
                    && keyHasOverrideValue("SUPPRESS_CCE_ENTRY_LINK_BY_CLIENT", userClientNumber)) {
                showCCEEntryLink = false;
            } else if (checkCCEAppConfigKey("SUPPRESS_CCE_ENTRY_LINK")) {
                showCCEEntryLink = false;
            }

            // Check SHOW_CCE_ENTRY_LINK[_BY_UMI|GROUP|CLIENT] AppConfig Keys.
            else if (checkCCEAppConfigKey("SHOW_CCE_ENTRY_LINK_BY_UMI")
                    && keyHasOverrideValue("SHOW_CCE_ENTRY_LINK_BY_UMI", userUMI)) {
                showCCEEntryLink = true;
            } else if (checkCCEAppConfigKey("SHOW_CCE_ENTRY_LINK_BY_GROUP")
                    && keyHasOverrideValue("SHOW_CCE_ENTRY_LINK_BY_GROUP", userGroupNumber)) {
                showCCEEntryLink = true;
            } else if (checkCCEAppConfigKey("SHOW_CCE_ENTRY_LINK_BY_CLIENT")
                    && keyHasOverrideValue("SHOW_CCE_ENTRY_LINK_BY_CLIENT", userClientNumber)) {
                showCCEEntryLink = true;
            } else if (checkCCEAppConfigKey("SHOW_CCE_ENTRY_LINK")) {
                showCCEEntryLink = true;
            }

            // Default - Check if the user hasCareCostEstimator.
            else {
                showCCEEntryLink = selectedPlan.hasCareCostEstimator && selectedPlan.hasCareCostEstimator === "true";
            }

            return showCCEEntryLink;
        };

        return {
            shouldDisplay: _shouldDisplay
        };
    }]);
    app.directive('healthcareTools', function() {
        return {
            restrict: 'A',
            templateUrl: 'home.appTemplate.html/chmhom/directives/landing/healthcareTools',
            controller: ['$scope', 'aemContent', 'services', 'finderService', 'displayOrHideItemsWrapper', 'finder-logic2', 'session', 'sessionData', 'brand', 'coremetrics', 'vendorSSOUtility', 'pharmacyServiceWrapper', 'cceService', 'modal', 'ebillUserExists', '$q', 'UMSParse', 'careCostEstimator',
                function($scope, aemContent, services, finderService, displayOrHideItemsWrapper, finderLogic, session, sessionData, brand, coremetrics, vendorSSOUtility, pharmacyServiceWrapper, cceService, modal, ebillUserExists, $q, umsParse, careCostEstimator) {




                // dojo polyfills
                var lang = {hitch: function(s, f) { return f.bind(s); }, replace: function(i,o) { var z = i.match(/\{.*?\}/g) || []; return z.reduce(function(a,c) { return a.replace(c,o[c.substring(1,c.length-1)]); }, i); }}
                var dojoArray = {forEach: function(a, f) { return a.forEach(f); }, indexOf: function(a, s) { return a.indexOf(s); }}
                var djArray = dojoArray;
                var all = $q.all;
                // "bootstrap/utilities/Modal",
                // "bootstrap/services/services",
                // "dojo/io-query",
                // "bootstrap/utilities/Article",
                // "app/articles/FormForPostRequest"
                var btsGlobal = {config: {brand: brand.current}, appConfig: sessionData.appConfig};

                // end dojo polyfills



                var myModel;
                var teleMedicineVendorKey;
                var teleMedicineTSContent;
                var allinaGroupsKey;
                var newPVDLink = (btsGlobal && btsGlobal.appConfig && btsGlobal.appConfig.LANDING && btsGlobal.appConfig.LANDING.NEW_PVD_HREF && btsGlobal.appConfig.LANDING.NEW_PVD_HREF.booleanValue && btsGlobal.appConfig.LANDING.NEW_PVD_HREF.overrideValue) ? btsGlobal.appConfig.LANDING.NEW_PVD_HREF.overrideValue + "#/home?" : false;
                var _isVitalsActive = (btsGlobal && btsGlobal.appConfig && btsGlobal.appConfig.PROVIDER && btsGlobal.appConfig.PROVIDER.VITALS_LIVE) ? btsGlobal.appConfig.PROVIDER.VITALS_LIVE.booleanValue : false;

                // var hasTeleMedicine = false;

                $scope.showFindProvider = true;
                $scope.showFormsLibrary = false;
                $scope.showBenefitSearch = false;

                // hide / show Healthy Tools and Teamsite values---------------------------------
                $scope.openTelemedicinePrompt = function() {
                    var that = this;

                    if(!that.cmVirtualMedicine){
                        coremetrics.elementTag(teleMedicineTSContent.coremetrics.elementTag,'MEMBER:MEMBER HOME');
                        that.cmVirtualMedicine = true;
                    }
                    if(!that.cmTeledocTermsConditionsPage){
                        coremetrics.pageviewTag(teleMedicineTSContent.coremetrics.mbrPageviewTag,'MEMBER:MEMBER HOME');
                        that.cmTeledocTermsConditionsPage = true;
                    }
                    var teleMedicineButtons ="";
                    dojoArray.forEach(teleMedicineTSContent.url, function(entry, i){
                        teleMedicineButtons +=
                            ('<button data-click="myCloseModal('+ i +')"  class="action-btn" >' +
                            entry.label + '</button>');

                    });

                    new bsModal('<p>' + teleMedicineTSContent.disclaimer  + '</p>' +
                                '<span class="text-l">' +
                                '<button data-click="closeModal()" class="action-btn">' + 'Cancel</button>' +
                                '</span>' +
                                '<span class="text-r" style="float: right">' + teleMedicineButtons + '</span>',
                                {
                                    currentMember: this.currentMember,
                                    myCloseModal: function (pIndex) {
                                        var openAsUrl = false;

                                        if (teleMedicineTSContent.sso && teleMedicineTSContent.sso[pIndex]) {
                                            var ssoParams = teleMedicineTSContent.sso[pIndex];

                                            var ssoAppConfig = null;
                                            if (ssoParams && ssoParams.disableAppConfigId && ssoParams.disableAppConfigId.length > 0 && btsGlobal && btsGlobal.appConfig && btsGlobal.appConfig.LANDING && btsGlobal.appConfig.LANDING[ssoParams.disableAppConfigId]) {
                                                ssoAppConfig = btsGlobal.appConfig.LANDING[ssoParams.disableAppConfigId];
                                            }

                                            if (ssoAppConfig !== null && ssoAppConfig.booleanValue === true) {
                                                // If the SSO is disabled by app config, open using URL instead of SSO.
                                                openAsUrl = true;
                                            } else {
                                                var telemedicineSSOPayload = {
                                                    "clientNumber": that.portalSelectedPlan.clientNumber,
                                                    "groupNumber": that.portalSelectedPlan.groupNumber,
                                                    "targetType": ssoParams.targetType,
                                                    "vendorName": ssoParams.vendorName,
                                                    "category": ssoParams.category
                                                };
                                                that.vendorSSORequest(telemedicineSSOPayload, ssoParams.sitePromotionStr, '_blank');
                                            }
                                        } else {
                                            openAsUrl = true;
                                        }

                                        if (openAsUrl) {
                                            var sitePromotionTag = teleMedicineTSContent.url[pIndex].href.concat("?").concat(teleMedicineTSContent.url[pIndex].coremetrics.sitePromotionTag);
                                            coremetrics.createManualLinkClickTag(sitePromotionTag, null, null);
                                            window.open(teleMedicineTSContent.url[pIndex].href, '_blank');
                                        }
                                        this.closeModal();
                                    },
                                    heading: teleMedicineTSContent.title
                                });
                };
                $scope.openVitalsSSOModal = function(){

                    coremetrics.elementTag('VITALS SMARTSHOPPER','MEMBER:MEMBER HOME');
                    coremetrics.pageviewTag('MEMBER:MEMBER HOME:VITAL SMARTSHOPPER MODAL','MEMBER:MEMBER HOME');

                    if(_isVitalsActive){
                        var siteToLeave = (window.location.host.toLowerCase().indexOf("mybenefitshome.com") > -1)?"Highmark": "Your health plan";

                        new bsModal('<div class="vitalsModal">' +
                            '<h1>YOU WILL BE REDIRECTED TO SAPPHIRE DIGITAL</h1>'+
                            '<article class="vitalsDisclaimerModal">\n' +
                            '    <p>By clicking “CONTINUE” below, you will be redirected to the Sapphire Digital website.\n' +
                            siteToLeave + ' has contracted with Sapphire Digital to provide members with access to the Sapphire Digital website.\n' +
                            '        Sapphire Digital is responsible for the Sapphire Digital website, including any terms of use, privacy policies, and/or other applicable conditions of use.\n' +
                            '        If you continue to the Sapphire Digital website, you will be subject to the website’s terms of use, privacy policies and other applicable conditions of use.\n' +
                            siteToLeave + ' makes no representations or warranties regarding the correctness, accuracy, performance or quality\n' +
                            '        of any content, software, service or application found at the Sapphire Digital Website.  If you decide to access the Sapphire Digital website, you do so at your own risk.</p>\n' +
                            '    <div class="modal-button-section">\n' +
                            '        <button type="button" class="action-btn primary" data-click="continueToDestination()">Continue</button>\n' +
                            '    </div>\n' +
                            '</article>' +
                            '</div>',
                            {
                                continueToDestination : function(){
                                    var ssoLinkBase = '/rbsmbl/x-services/public/sapphire/sso/' + btsGlobal.config.brand.sharedBrandCode + '/member';
                                    window.open(ssoLinkBase);
                                    this.closeModal();
                                }
                            });
                    } else {
                        new bsModal(vitalsModal,
                            lang.mixin({}, this, {
                                ssoToVitals: function () {
                                    var vitalsSSOPayload = {
                                        "clientNumber": this.portalSelectedPlan.clientNumber,
                                        "groupNumber": this.portalSelectedPlan.groupNumber,
                                        "targetType": 'LANDING',
                                        "vendorName": 'vitalsSmartShopper',
                                        "category": ''
                                    };
                                    vendorSSOUtility.vendorSSORequest(vitalsSSOPayload, this.userName, this.baseInformation.brand, 'Vitals%20SmartShopper-_-SmartShopper', '_blank');
                                }
                            }));
                    }
                };
                $scope.cmFindProvider = function(targetUrl) {
                    var that = this;
                    if(that.cmFindProviderClicked != true){
                        // Site promotion tag
                        coremetrics.createManualLinkClickTag(targetUrl,null,null);
                        //coremetrics.elementTag('FIND A PROVIDER','MEMBER:MEMBER HOME');
                        that.cmFindProviderClicked = true;
                    }
                };
                $scope.cmPrescriptionServices = function(targetUrl) {
                    var that = this;
                    if (that.cmPrescriptionServicesClicked != true) {
                        // Site promotion tag
                        coremetrics.createManualLinkClickTag(targetUrl, null, null);
                        // coremetrics.elementTag('PRESCRIPTION SERVICES','MEMBER:MEMBER HOME');
                        that.cmPrescriptionServicesClicked = true;
                    }
                    if ((targetUrl.indexOf('catamaran') > -1) || (targetUrl.indexOf('medco') > -1)) {
                        // these members just go directly to a url
                        var theDomain = 'https://' + window.location.host;
                        theDomain = theDomain.split('den').join('ten');
                        window.open(theDomain + targetUrl);
                        return;
                    } else if (targetUrl.indexOf('://') > -1) {
                        window.open(targetUrl);
                        return;
                    }

                    var prescSvcPayload = {
                        "umi": that.baseInformation.umi,
                        "firstName": that.currentMember.firstName,
                        "lastName": that.currentMember.lastName,
                        "dateOfBirth": that.currentMember.dob,
                        "gender": that.currentMember.gender,
                        "relationshipCode": that.currentMember.relationshipCode,
                        "directPaySeniorMember": that.portalSelectedPlan.directPayIndicator,
                        "targetType": "Coverage",
                        "relationship": that.currentMember.relationship,
                        "clientid": that.portalSelectedPlan.clientNumber,
                        "vendorName": that.portalSelectedPlan.pharmacyBenefitProviderIndicator
                    };

                    // TODO: Update once IE fix is determined...
                    //var ssoWindowName = ('sso_pharmacy' + prescSvcPayload.vendorName).toLowerCase();
                    //vendorSSOUtility.launchNewSsoWindow(ssoWindowName);
                    var ssoWindowName = "_blank";
                    var sharedCode = btsGlobal.config.brand.sharedBrandCode;
                    if(sharedCode.toLowerCase() == "hmbcbswv"){
                        sharedCode = "ms";
                    }

                   services.sso.PrescriptionServices.getData(that.userName, sharedCode.toUpperCase(), prescSvcPayload).then(function (presResp) {
                        var sitePromo = "";
                        var curPBMIndicator = that.portalSelectedPlan.pharmacyBenefitProviderIndicator;

                        if (curPBMIndicator === "Medco" || curPBMIndicator === "Prime" || curPBMIndicator === "ExpressScripts") {
                            sitePromo = "cm_sp=" + curPBMIndicator + "-_-Prescription%20Services%20" + curPBMIndicator + "-_-PRESCRIPTION%20SERVICES";
                        }
                        vendorSSOUtility.handleSSOResponse(presResp, sitePromo, ssoWindowName);

                    }, function (error) {
                        vendorSSOUtility.handleSSOFailure(error, ssoWindowName);
                    });
                };
                $scope.cmCompareCosts = function() {
                    var that = this;
                    if(that.cmCompareCostsClicked != true){
                        coremetrics.elementTag('Estimates Costs for Care','MEMBER:MEMBER HOME');
                        that.cmCompareCostsClicked = true;
                    }
                };
                $scope.cmPayPlanPremium = function(targetUrl) {
                    var that = this;
                    if(that.cmPayPlanPremiumClicked != true){
                        // Site promotion tag
                        targetUrl += "?cm_sp=Ebill-_-Pay%20Monthly%20Premium-_-PAY%20MONTHLY%20PREMIUM";
                        coremetrics.createManualLinkClickTag(targetUrl,null,null);
                        //coremetrics.elementTag('PAY MONTHLY PREMIUM','MEMBER:MEMBER HOME');
                        that.cmPayPlanPremiumClicked = true;
                    }
                };
                $scope.cmSavingsAdvisor = function() {
                    var that = this;
                    var sitePromo="";
                    if(that.cmSavingsAdvisorClicked != true){
                        coremetrics.elementTag('Savings Advisor Link','MEMBER:MEMBER HOME');
                        that.cmSavingsAdvisorClicked = true;
                    }
                    var savingsAdvisorPayload = {
                        "clientNumber": that.portalSelectedPlan.clientNumber,
                        "groupNumber": that.portalSelectedPlan.groupNumber,
                        "targetType": "landingPage",
                        "vendorName": "",
                        "category":"savingsAdvisor"
                    };
                    that.vendorSSORequest(savingsAdvisorPayload, sitePromo, '_blank');
                };
                $scope.cmMyChart = function(){
                    coremetrics.elementTag('MYCHART LINK','MEMBER:MEMBER HOME');
                    window.open(this.targetUrls.myChartUrl, "_self");
                };
                $scope.vendorSSORequest = function(requestPayload, coremetricsSP, targetLocation) {
                    var that = this;
                    vendorSSOUtility.vendorSSORequest(requestPayload, that.userName, that.baseInformation.brand, coremetricsSP, targetLocation);
                };
    
                var toMerge = {
                    myInit: function() {
                        $scope.showPayPlanPremiumRegistered = false;
                        $scope.showPayPlanPremiumUnregistered = false;
                        $scope.showPrescriptionCostandRefills = true;
                        $scope.targetUrls = {
                            payPremiumUnregistered: {},
                            payPremiumRegistered: {}
                        };
                    },

                    useThis: function(tsValue, fallBackValue) {
                        var strThis = (tsValue && tsValue.length > 0) ? tsValue : fallBackValue;
                        return strThis;
                    },
                    handleTeamsiteResponse: function(ts) {
                        // TODO: This code is ridiculous. What does it do?
                        var m = $scope;
                        for (var theName in ts) {
                            // Spamming.  Turn logs off when you're done with testing.
                        }
                     },
                    getThisCurrentlyActiveProduct: function(planType) {
                        var m = $scope;
                        var theProduct = null;
                        var currentProducts = this.getCurrentProducts(m);

                        for(i=0; i< currentProducts.length; i++){
                           if(currentProducts[i].benefitPlanType == planType){
                               theProduct = currentProducts[i];
                               return theProduct;
                           }
                        }
                        return theProduct;
                    },
                    getThisCurrentlyActiveProductRxList: function(planType) {
                        var m = $scope;
                        var theProductList = [];
                        var theProduct = null;
                        var currentProducts = this.getCurrentProductsRx(m);
                        djArray.forEach(currentProducts, function(item){
                                theProduct = (item.benefitPlanType == planType) ? item : null;
                                if(theProduct != null){
                                theProductList.push(item);
                            }
                        });
                        return theProductList;
                    },
                    getCurrentProductsRx: function(m) {
                        var currentPlans = []
                        if (m.portalSelectedPlan &&
                            m.portalSelectedPlan.productList &&
                            m.portalSelectedPlan.productList.length &&
                            m.portalSelectedPlan.productList.length > 0) {
                            var ps = m.portalSelectedPlan.productList;
                            // get the current plans
                            var coverageIsCurrent = false;
                            var milliServerDate = Date.parse(m.serverDate);
                             for(var i=0;i<ps.length;i++)
                                {
                                     var millisBeginDate;
                                     if(ps[i].coverageBeginDate != null && ps[i].coverageBeginDate != "")
                                         millisBeginDate = Date.parse(ps[i].coverageBeginDate);
                                     else if (ps[i].coverageConBeginDate != null && ps[i].coverageConBeginDate != "")
                                         millisBeginDate = Date.parse(ps[i].coverageConBeginDate);
                                     
                                     var millisEndDate = Date.parse(ps[i].coverageEndDate);
                                     coverageIsCurrent = ((millisBeginDate < milliServerDate) && (( milliServerDate < millisEndDate ) || (!ps[i].coverageEndDate))) ? true : false;  // 12/31/2014
                                     if (coverageIsCurrent) {
                                         currentPlans.push(ps[i]);
                                     }
                                     coverageIsCurrent = false;
                                }
                        }
                        return currentPlans;
                    },
                    getCurrentProducts: function() {
                        var m = $scope;
                        var currentPlans = []
                        if (m.portalSelectedPlan &&
                            m.portalSelectedPlan.productList &&
                            m.portalSelectedPlan.productList.length &&
                            m.portalSelectedPlan.productList.length > 0) {
                            var ps = m.portalSelectedPlan.productList;
                            // get the current plans
                            var coverageIsCurrent = false;
                            var milliServerDate = Date.parse(m.serverDate)
                            djArray.forEach(ps, function (item) {
                                var millisBeginDate = Date.parse(item.coverageBeginDate);
                                var millisEndDate = Date.parse(item.coverageEndDate);
                                coverageIsCurrent = ((millisBeginDate < milliServerDate) && ( milliServerDate < millisEndDate )) ? true : false;  // 12/31/2014
                                if (coverageIsCurrent) {
                                    currentPlans.push(item);
                                }
                                coverageIsCurrent = false;
                            })
                        }
                        return currentPlans;
                    },
                    getCanceledProducts: function(planType){
                        var currentPlans = [];
                        var m = $scope;
                        var theProduct = null;
                        
                        if (m.portalSelectedPlan &&
                            m.portalSelectedPlan.productList &&
                            m.portalSelectedPlan.productList.length &&
                            m.portalSelectedPlan.productList.length > 0) {
                            var ps = m.portalSelectedPlan.productList;
                            // get the current plans
                            var coverageIsCancelled = false;
                            var milliServerDate = Date.parse($scope.serverDate);
                            djArray.forEach(ps, function (item) {
                                var millisBeginDate = Date.parse(item.memberList[0].coverageEffectiveDate);
                                var millisEndDate = Date.parse(item.memberList[0].coverageCancellationDate);

                                //converts milliseconds to days
                                var beginDays = Math.floor(millisBeginDate/86400000);
                                var endDays = Math.floor(millisEndDate/86400000);

                                coverageIsCancelled = ( endDays - beginDays <= 90) ? true : false;
                                if (coverageIsCancelled) {
                                    currentPlans.push(item);
                                }
                                coverageIsCancelled = false;
                            });
                        }

                        djArray.forEach(currentPlans, function(item){
                            theProduct = (item.benefitPlanType == planType) ? item : theProduct;
                        });
                        return theProduct;
                    },
                    populateModel: function(the_model, portalSelectedPlan) {
                        // handle the stuff returned from Teamsite
                        var m = the_model;
                        var psp = portalSelectedPlan;

                        m.isVitalsActive = _isVitalsActive;
                       // Coremetrics Site Promotion parameter query tag.
                        var cmSP;

                        // debugger;
                        this.handleTeamsiteResponse(m.tsResponse);

                        m.showVitals = (psp.vitalsSmartShopper === true) ? true : false;
                        
                        // Pay Plan Premium -- (Direct Pay or Senior) and Subscriber ---------------------

                        var isASubscriber = (m.currentMember.relationship == 'Subscriber') ? true : false;
                        var medicalPlan = this.getThisCurrentlyActiveProduct('Medical');
                        var isQualifiedSenior = (medicalPlan && medicalPlan.seniorProductIndicator == 'true') ? true : false;
                        var isDirectPay = (psp && psp.directPayIndicator && psp.directPayIndicator == 'true') ? true : false;
                        
                        if(btsGlobal.config.brand.sharedBrandCode === "mincr")
                        {
                            m.showPayPlanPremium = (isQualifiedSenior || isDirectPay && isASubscriber);
                        }
                        else{
                            m.showPayPlanPremium = (isQualifiedSenior || isDirectPay && isASubscriber);
                        }


                        if (m.showPayPlanPremium) {
                            // call the service only if we are showing the Pay Plan Premium item

                            $scope.targetUrls.payPremiumRegistered = (m.tsResponse["MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_REGISTERED"])
                                ? JSON.parse(m.tsResponse["MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_REGISTERED"])
                                : {"defaultText": "", "href":"", "target":""};
                            $scope.targetUrls.payPremiumUnregistered = (m.tsResponse["MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_UNREGISTERED"])
                                ? JSON.parse(m.tsResponse["MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_UNREGISTERED"])
                                : {"defaultText": "", "href":"", "target":""};

                            services.rbsmbl.ebillUserExists().get().then(
                                lang.hitch(this, function (response) {
                                    var unregistered = response &&
                                            response.data &&
                                            response.data.payload &&
                                            response.data.payload.ebillAccountexists === "N";

                                    m.showPayPlanPremiumUnregistered = unregistered;
                                    m.showPayPlanPremiumRegistered = !unregistered;

                                }),
                                lang.hitch(this, function () {
                                    m.showPayPlanPremiumUnregistered = true;
                                })
                            );
                            //TODO: verify to put all brands other than  IBC && MINCR
                            var payPremiumEnabledBrands = ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'mn', 'pp', '6011', 'la'];
                            var shouldGoToBilling = (payPremiumEnabledBrands.indexOf(btsGlobal.config.brand.sharedBrandCode) !== -1);

                            if(shouldGoToBilling){
                                /*$scope.targetUrls.payPremiumUnregistered= (m.tsResponse["MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_EBILL"])
                                ? JSON.parse(m.tsResponse["MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_EBILL"])
                                : {"defaultText": "", "href":"", "target":""};
                                $scope.targetUrls.payPremiumRegistered.href = (m.tsResponse["MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_EBILL"])
                                ? JSON.parse(m.tsResponse["MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_EBILL"])
                                : {"defaultText": "", "href":"", "target":""};*/

                                $scope.targetUrls.payPremiumRegistered = (m.tsResponse["MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_REGISTERED_NEW"])
                                    ? JSON.parse(m.tsResponse["MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_REGISTERED_NEW"])
                                    : {"defaultText": "", "href":"", "target":""};
                                $scope.targetUrls.payPremiumUnregistered = (m.tsResponse["MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_UNREGISTERED_NEW"])
                                    ? JSON.parse(m.tsResponse["MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_UNREGISTERED_NEW"])
                                    : {"defaultText": "", "href":"", "target":""};

                                
                            }
                        }

                        // Prescription Services =============================================================================
                        // this can have values like  “Medco”, “Catalyst”, “RX Claim”, “RX Claim – Commercial”, “None”
                        var thisSharedBrandCode = btsGlobal.config.brand.sharedBrandCode;
                        var arrayStateCodes = ["inac", "ibc", "ibccr", "ibx", "ibcah"];
                        var isIbcRelated = (dojoArray.indexOf(arrayStateCodes, thisSharedBrandCode) > -1) ? true : false;
                        var currentMedicalProduct = this.getThisCurrentlyActiveProduct('Medical');   // that method handles only current products

                        var currentRxProductList = this.getThisCurrentlyActiveProductRxList('Drug');

                        if (currentMedicalProduct) {
                            var pharmacyBenefitProvider = (psp && psp.pharmacyBenefitProviderIndicator && psp.pharmacyBenefitProviderIndicator.length > 0) ?
                                psp.pharmacyBenefitProviderIndicator : null;
                            pharmacyBenefitProvider = (pharmacyBenefitProvider == 'None') ? null : pharmacyBenefitProvider;
                            var arrPharmacyProvider = ['Medco', 'Catalyst', 'RX Claim', 'RX Claim – Commercial', 'Prime',
                                'CVS/Caremark', 'Navitus', 'Envision', 'Optum', 'ESI'];
                            if (djArray.indexOf(arrPharmacyProvider, pharmacyBenefitProvider) > -1) {
                                m.showPrescriptionServices = true;
                                var url = null;
                                // NOTE:  these urls do NOT show up on hover in the browser. The Core Metrics programmer
                                // NOTE:  hard coded cmPrescriptionService method in the html
                                // NOTE:  so these urls are now used there
                                switch(pharmacyBenefitProvider) {
                                    case 'Medco':
                                        url = '/rbsmbl/x-services/singleSignon/v1/prescriptionServices';
                                        break;
                                    case 'Prime':
                                        url = '/rbsmbl/x-services/singleSignon/v1/prescriptionServices';
                                        break;
                                    case 'CVS/Caremark':
                                        url = 'https://www.caremark.com/wps/portal';
                                        break;
                                    case 'Navitus':
                                        url = 'https://members.navitus.com';
                                        break;
                                    case 'Envision':
                                        url = 'https://www.envisionrx.com/resources/pharmacymap.aspx';
                                        break;
                                    case 'Optum':
                                        url = 'https://www.optumrx.com/RxSolWeb/mvc/home.do';
                                        break;
                                    case 'ESI':
                                        url = 'https://www.express-scripts.com/index.html';
                                        break;
                                    default:
                                        url = "/chmptl/chm/jsp/singleSignOn.do?vendor=catamaran";
                                }
                                m.targetUrls.prescriptionService = url;
                            } else {
                                // they do not have a pharmacyBenefitProvider but they still may get the item
                                var hasRxClaims = (currentMedicalProduct.rxClaims == 'true') ? true : false;
                                if (!hasRxClaims) {
                                    var medicalPlanDrugCoverage = (currentMedicalProduct.drugCoverage == 'true') ? true : false;
                                    var integratedCovIndicator = (currentMedicalProduct.integratedCoverageIndicator == 'true') ? true : false;
                                    var hasIntegratedDrugCoverage = (medicalPlanDrugCoverage && integratedCovIndicator ) ? true : false;
                                    var theLob = currentMedicalProduct.lob;
                                    var arrPossibleLobValues = ['HMO', 'PPO', 'EPO', 'HDHP', 'CV', 'POS', 'TDL'];
                                    var hasRequiredLob = (djArray.indexOf(arrPossibleLobValues, theLob) > -1) ? true : false;
                                    if (hasRequiredLob && hasIntegratedDrugCoverage) {
                                        // if their brand is NOT IBC, show the item and link it like Medco
                                        if (!isIbcRelated) {
                                            m.targetUrls.prescriptionService = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_RX_LINK_HREF, 'MBR_MBRHOME_HEALTHTOOLS_RX_LINK_HREF');
                                            m.showPrescriptionServices = true;
                                        } else {
                                            // hide the item
                                            m.showPrescriptionServices = false;
                                        }
                                    }
                                } else {
                                    // rxClaims is true (and other conditions are not true) so we do not show the item
                                    m.showPrescriptionServices = false;
                                }
                            }
                        }
                        // Show prescription service link for Standalone Rx users.
                        
                        if(currentRxProductList && currentRxProductList.length){
                            var    currentRxProduct = currentRxProductList[0];
                             var rxPlanDrugCoverage = (currentRxProduct.drugCoverage == 'true') ? true : false;
                             var hasRequiredLob = (currentRxProduct.lob == 'PDG' || currentRxProduct.lob == 'pdg' ) ? true : false;
                                var pharmacyBenefitProvider = (psp && psp.pharmacyBenefitProviderIndicator && psp.pharmacyBenefitProviderIndicator.length > 0) ?
                                    psp.pharmacyBenefitProviderIndicator : null;
                                pharmacyBenefitProvider = (pharmacyBenefitProvider == 'None') ? null : pharmacyBenefitProvider;
                                var arrPharmacyProvider = ['Medco', 'Catalyst', 'RX Claim', 'RX Claim – Commercial', 'Prime'];
                                if (djArray.indexOf(arrPharmacyProvider, pharmacyBenefitProvider) > -1) {
                                    m.showPrescriptionServices = true;
                                    if (pharmacyBenefitProvider == 'Medco') {
                                     // m.targetUrls.prescriptionService = '/chmptl/chm/jsp/medco/medco.jsp?typeMEDCO=mailrx';
                                     m.targetUrls.prescriptionService = '/rbsmbl/x-services/singleSignon/v1/prescriptionServices';
                                     //                                  /chmptl/chm/jsp/medcoRouter.do?typeMEDCO=
                                 }
                                 else if (pharmacyBenefitProvider == 'Prime')
                                 {
                                     m.targetUrls.prescriptionService = "/chmptl/chm/jsp/singleSignOn.do?vendor=prime";
                                 }
                                 else {
                                     m.targetUrls.prescriptionService = "/chmptl/chm/jsp/singleSignOn.do?vendor=catamaran";
                                 }
                            } // end if PharmacyBenefitProvider
                            else{
                                       if(rxPlanDrugCoverage && hasRequiredLob ){
                                        if (!isIbcRelated) {
                                               m.targetUrls.prescriptionService = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_RX_LINK_HREF, 'MBR_MBRHOME_HEALTHTOOLS_RX_LINK_HREF');
                                               m.showPrescriptionServices = true;
                                           }
                                           else{
                                               // hide the item
                                               m.showPrescriptionServices = false;
                                           }
                                       }
                                       else{
                                           m.showPrescriptionServices = false;
                                       }
                                           
                            } // else PharmacyBenefitProvider
                       } // end Rx Product

                        if(!m.showPrescriptionServices){
                            var cancelledMedicalProduct = this.getCanceledProducts('Drug');
                            if(cancelledMedicalProduct){
                                m.showPrescriptionServices = true;
                            }
                        }

                        if (!m.showPrescriptionServices) {
                            // Rx carve-outs do not have drug products or a value returned for pharmacyBenefitProviderIndicator.
                            // So we must check if the member is part of a client that has a Rx carve-out pharmacy vendor.
                            $scope.memberQualifiers.then(lang.hitch(this, function (response) {
                                if (response && response.data && response.data.payload && response.data.payload.qualifierInfo &&
                                        response.data.payload.qualifierInfo.rxCarveOutVendor && response.data.payload.qualifierInfo.rxCarveOutVendor.length > 0) {

                                    m.showPrescriptionServices = true;
                                    m.targetUrls.prescriptionService = response.data.payload.qualifierInfo.rxCarveOutVendor;
                                    m.portalSelectedPlan.pharmacyBenefitProviderIndicator = response.data.payload.qualifierInfo.rxCarveOutVendor;
                                }
                            }));
                        }

                        var brandCode = btsGlobal.config.brand.sharedBrandCode;

                        // Teledoc ====================================================================

                        //m.showTelemedicine = hasTeleMedicine;

                        // Savings Adviser =============================================================
                        var booShowSA =  (psp && psp.chcIndicator && psp.chcIndicator && psp.chcIndicator == 'true') ? true : false;
                        // var booShowSA = ((acctSettings.isCHC == 'true') || (acctSettings.isCHC == true)) ? true : false;

                        //For Minnesota - Show CHC link for subscribers and dependents
                        //Everyone else - Show only for subscribers
                        if(booShowSA) {
                            if (brandCode.toLowerCase() !== 'mincr') {
                                if (!isASubscriber) {
                                    booShowSA = false;
                                }
                            }
                        }

                        //Prescription Cost & Refills - hide based on pre effectuated flag
                        var toolsPreEffectuatedService = $scope.toolsPreEffectuated;
                        var isToolsPreEffectuated = toolsPreEffectuatedService.isPreEffectuated;
                        var toolsPreEffectuatedBrands = ['hmbcbs', 'hbs', 'hmbcbswv', 'hmbcbsde', 'pp'];
                        if ((djArray.indexOf(toolsPreEffectuatedBrands, brandCode.toLowerCase()) > -1) && (isToolsPreEffectuated == true)) {
                            $scope.showPrescriptionCostandRefills = false;
                        }


                        var formsLibraryBrands = ['hmbcbs', 'hbs', 'hmbcbswv', 'hmbcbsde', 'pp'];
                        if (djArray.indexOf(formsLibraryBrands, brandCode.toLowerCase()) > -1) {
                            $scope.showFormsLibrary = true;
                            if (btsGlobal
                                && btsGlobal.appConfig
                                && btsGlobal.appConfig.COVERAGE
                                && btsGlobal.appConfig.COVERAGE.BENEFIT_SEARCH_MAINTENANCE
                                && btsGlobal.appConfig.COVERAGE.BENEFIT_SEARCH_MAINTENANCE.booleanValue === false) {
                            $scope.showBenefitSearch = true;
                            }

                        }            

                        m.showSavingsAdvisor = booShowSA;  // true;  //booShowSA;
                        var gn = portalSelectedPlan.groupNumber;

                        // Care Cost Estimator -----------------------------------------------------------------------------------
                        var umi = $scope.baseInformation.umi,
                            clientNumber = $scope.currentMember.clientNumber;
                        m.showCompareCosts = careCostEstimator.shouldDisplay($scope.portalSelectedPlan, umi, clientNumber);
                       
                        /*Tools Titles*/
                        $scope.tsToolsTitle = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_TITLE, 'HEALTH CARE TOOLS').toUpperCase();
                        $scope.tsToolsDesc = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_DESCRIPTION, 'Use these tools to help manage costs and plan for your care.');
                     
                        /*Tools Links Titles*/
                        $scope.tsFindProvider = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_PROVIDER_LINK, 'Find a Doctor');
                        $scope.tsPrescriptionServices = this.useThis(m.qualifiedTeamsiteContent.MBR_MBRHOME_HEALTHTOOLS_RX_LINK, 'Prescription Costs & Refills');
                        $scope.tsCompareCosts = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_COMPCOST_LINK, 'Care Cost Estimator');
                        $scope.tsCastlight = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_CASTLIGHT_LINK, 'MBR_MBRHOME_HEALTHTOOLS_CASTLIGHT_LINK');
                        $scope.tsMyChart = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_MYCHART_LINK, 'My Chart');
                        $scope.tsSmartshopper = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_SMARTSHOPPER_LABEL, 'MBR_MBRHOME_HEALTHTOOLS_SMARTSHOPPER_LABEL');

                        $scope.tsFormsLibrary = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_FORMS_LIBRARY, 'Find Forms').toUpperCase(); 
                        $scope.targetUrls.formsLibrary = this.useThis(m.tsResponse.MBR_MBRHOME_FORMS_LIBRARY_LINK_HREF, '/member/forms');
                        $scope.tsBenefitSearch = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_BENEFIT_SEARCH, 'MEDICAL BENEFIT SEARCH').toUpperCase(); 
                        $scope.targetUrls.benefitSearch = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_BENEFIT_SEARCH_LINK, 'MBR_MBRHOME_HEALTHTOOLS_BENEFIT_SEARCH_LINK');

                        var vitalsModalContent = m.tsResponse.MBR_MBRHOME_VITALS_MODAL;
                        $scope.vitalsModal = JSON.parse(vitalsModalContent);

                        if(brandCode.toLowerCase()==='mincr'){
                            $scope.tsSavingsAdvisor = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK_MINCR,'MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK_MINCR');
                        }
                        else{
                            $scope.tsSavingsAdvisor = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK,'MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK');
                        }

                        /*Tools Target Urls*/
                        $scope.targetUrls.findAProvider = newPVDLink ? newPVDLink : this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_PROVIDER_LINK_HREF, '/find-a-doctor/landing');//'/chmptl/chm/jsp/memberCategory.do?tab=4';
                        //var targetCce = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_COMPCOST_LINK_HREF, 'MBR_MBRHOME_HEALTHTOOLS_COMPCOST_LINK_HREF');///cce/landing-page.html
                        var isGeneralMills = $scope.currentMember.clientNumber;
                        if(isGeneralMills == "179986"){
                            $scope.showtsCastlight = true;
                            $scope.showtsCompareCosts = false;
                            var targetCce = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_CASTLIGHT_LINK_HREF, 'MBR_MBRHOME_HEALTHTOOLS_CASTLIGHT_LINK_HREF');///cce/landing-page.html
                        } else {
                            $scope.showtsCastlight = false;
                            $scope.showtsCompareCosts = true;
                            var targetCce = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_COMPCOST_LINK_HREF, 'MBR_MBRHOME_HEALTHTOOLS_COMPCOST_LINK_HREF');///cce/landing-page.html

                        }

                       if (currentMedicalProduct && currentMedicalProduct.memberList && currentMedicalProduct.memberList.length > 0 && currentMedicalProduct.memberList[0].coverageEffectiveDate) {
                            var ed = currentMedicalProduct.memberList[0].coverageEffectiveDate,
                            theRegion = btsGlobal.config.brand.domain;

                            ed = ed && ed.replace(/\//gi, '');
                            targetCce = targetCce.split('groupNo').join(gn);
                            targetCce = targetCce.split('effDate').join(ed);
                            m.targetUrls.compareCostsUrl = (!m.isVitalsActive) ? '..' + targetCce : '/rbsmbl/x-services/public/sapphire/sso/' + btsGlobal.config.brand.sharedBrandCode + '/member';
                            m.showCompareCostModal = function(){
                                var url = this.targetUrls.compareCostsUrl;
                                var sourceSite = (btsGlobal.config.brand.domain.toLowerCase())? "Highmark":"Your health plan";
                                var cceModal = new bsModal(
                                    '<div class="vitalsModal">' +
                                    '<h1>YOU WILL BE REDIRECTED TO SAPPHIRE DIGITAL</h1>'+
                                    '<article class="vitalsDisclaimerModal">'+
                                    '<p>By clicking “CONTINUE” below, you will be redirected to the Sapphire Digital website.'+
                                    sourceSite + ' has contracted with Sapphire Digital to provide members with access to the Sapphire Digital website.'+
                                    'Sapphire Digital is responsible for the Sapphire Digital website, including any terms of use, privacy policies, and/or other applicable conditions of use.'+
                                    'If you continue to the Sapphire Digital website, you will be subject to the website’s terms of use, privacy policies and other applicable conditions of use.'+
                                    sourceSite + ' makes no representations or warranties regarding the correctness, accuracy, performance or quality'+
                                    'of any content, software, service or application found at the Sapphire Digital Website.  If you decide to access the Sapphire Digital website, you do so at your own risk.</p>'+
                                    '<div class="modal-button-section">'+
                                    '<button type="button" class="action-btn primary" data-click="continueToDestination()">Continue</button>'+
                                    '</div>'+
                                    '</article>' +
                                    '</div>',
                                    {
                                        continueToDestination: function() {
                                            var theDomain = url;
                                            window.open(theDomain);
                                            this.closeModal();
                                        }
                                    }
                                );
                            };
                            if(theRegion == 'highmarkbcbs.com'){
                                $scope.showMyChart = true;
                                $scope.targetUrls.myChartUrl = m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_MYCHART_LINK_HREF;
                            }
                        }
                        else{
                            $scope.showCompareCosts = false;
                        }

                        var saLink = this.useThis(m.tsResponse.MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK_HREF, 'MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK_HREF');//'/wts/?gn='+ gn +'&ed=' + ed;
                        $scope.targetUrls.savingsAdvisorUrl = '../' + saLink;
                        //populating the query params for savings advisor target url
                        $scope.targetUrls.savingsAdvisorUrl = lang.replace($scope.targetUrls.savingsAdvisorUrl, {
                            groupNumber: gn,
                            effectiveDateMMDDYYYY: ed
                        });

                        // Adding cm_sp parameter for Coremetrics Site Promotion tags.
                        // Prescription Services
                        //Determine if Catamaran, Medco, or Prime
                        if ($scope.targetUrls.prescriptionService) {
                            var doWeirdURLConfig = false;
                            if ($scope.targetUrls.prescriptionService.indexOf("medco") > -1) {
                                cmSP = "&cm_sp=Medco-_-Prescription Services Medco-_-";
                                doWeirdURLConfig = true;
                            } else if ($scope.targetUrls.prescriptionService.indexOf("catamaran") > -1) {
                                cmSP = "&cm_sp=Catamaran-_-Prescription Services Catamaran-_-";
                                doWeirdURLConfig = true;
                            } else if ($scope.targetUrls.prescriptionService.indexOf("prime") > -1) {
                                cmSP = "&cm_sp=Prime-_-Prescription Services Prime-_-";
                                doWeirdURLConfig = true;
                            }
                            if (doWeirdURLConfig) {
                                cmSP = cmSP + $scope.tsPrescriptionServices.toUpperCase();
                                cmSP = cmSP.replace(/ /g,'%20');
                                $scope.targetUrls.prescriptionService = $scope.targetUrls.prescriptionService + cmSP;                    
                            } else {
                                var nonSSOVendors = ['CVS/Caremark', 'Navitus', 'Envision', 'Optum', 'ESI'];
                                if (nonSSOVendors.indexOf($scope.targetUrls.prescriptionService) > -1) {
                                    var nonSSOUrl = "";
                                    switch($scope.targetUrls.prescriptionService) {
                                        case 'CVS/Caremark':
                                            nonSSOUrl = 'https://www.caremark.com/wps/portal';
                                            break;
                                        case 'Navitus':
                                            nonSSOUrl = 'https://members.navitus.com';
                                            break;
                                        case 'Envision':
                                            nonSSOUrl = 'https://www.envisionrx.com/resources/pharmacymap.aspx';
                                            break;
                                        case 'Optum':
                                            nonSSOUrl = 'https://www.optumrx.com/RxSolWeb/mvc/home.do';
                                            break;
                                        case 'ESI':
                                            nonSSOUrl = 'https://www.express-scripts.com/index.html';
                                            break;
                                        default:
                                            break;
                                    }
                                    $scope.targetUrls.prescriptionService = nonSSOUrl;
                                }
                            }
                        }
                        // Find a Provider
                        cmSP = "&cm_sp=PRISM-_-Find A Provider-_-" + $scope.tsFindProvider.toUpperCase();
                        cmSP = cmSP.replace(/ /g,'%20');
                        $scope.targetUrls.findAProvider = $scope.targetUrls.findAProvider + cmSP;


                        this.populateAdditionalLinks();

                    },

                    populateAdditionalLinks: function(){
                        var rightRowIndex=0;
                        rightRowIndex=$scope.showFindProvider?rightRowIndex+1:rightRowIndex;
                        rightRowIndex=$scope.showPrescriptionServices?rightRowIndex+1:rightRowIndex;
                        rightRowIndex=$scope.showCompareCosts?rightRowIndex+1:rightRowIndex;
                        rightRowIndex=$scope.showFormsLibrary?rightRowIndex+1:rightRowIndex;
                        rightRowIndex=$scope.showBenefitSearch?rightRowIndex+1:rightRowIndex;
                        
                        var leftRowIndex=0;
                        leftRowIndex=$scope.showPayPlanPremium?leftRowIndex+1:leftRowIndex;
                        leftRowIndex=$scope.showTelemedicine?leftRowIndex+1:leftRowIndex;
                        leftRowIndex=$scope.showSavingsAdvisor?leftRowIndex+1:leftRowIndex;
                        leftRowIndex=$scope.showMyChart?leftRowIndex+1:leftRowIndex;
                        leftRowIndex=$scope.showVitals?leftRowIndex+1:leftRowIndex;            

                        var tsResponse=$scope.clientGroupProductQualifiedTSContent;
                        //These additionalLinks teamsite ids are all disabled. 
                        var additionalLinks=[{
                            'linkObj': tsResponse.MBR_MBRHOME_HEALTH_TOOLS_LINK1?JSON.parse(tsResponse.MBR_MBRHOME_HEALTH_TOOLS_LINK1):tsResponse.MBR_MBRHOME_HEALTH_TOOLS_LINK1,
                            'imgUrl': tsResponse.MBR_MBRHOME_HEALTH_TOOLS_LINK1_IMG
                        },{
                            'linkObj': tsResponse.MBR_MBRHOME_HEALTH_TOOLS_LINK2?JSON.parse(tsResponse.MBR_MBRHOME_HEALTH_TOOLS_LINK2):tsResponse.MBR_MBRHOME_HEALTH_TOOLS_LINK2,
                            'imgUrl': tsResponse.MBR_MBRHOME_HEALTH_TOOLS_LINK2_IMG
                        }, {
                            'linkObj': tsResponse.MBR_MBRHOME_HEALTH_TOOLS_LINK3?JSON.parse(tsResponse.MBR_MBRHOME_HEALTH_TOOLS_LINK3):tsResponse.MBR_MBRHOME_HEALTH_TOOLS_LINK3,
                            'imgUrl': tsResponse.MBR_MBRHOME_HEALTH_TOOLS_LINK3_IMG
                        }
                        ];

                        additionalLinks=additionalLinks.filter(function(link){
                            return (link.linkObj && link.linkObj.target && link.linkObj.target.length)>0?true:false;
                        });

                        var totalRowIndex=rightRowIndex+leftRowIndex+additionalLinks.length;
                        //this offset is used to default the link in right section, if there are odd number of links
                        var offset=(totalRowIndex%2)===0?0:1;
                        $scope.leftColumnLinks=additionalLinks.slice(0,(totalRowIndex/2)-rightRowIndex+offset);
                        $scope.rightColumnLinks=additionalLinks.slice($scope.leftColumnLinks.length,additionalLinks.length);
                    },

                    isHmo: function(theProducts) {
                      var lobIsHmo = false;
                      var hasHmo = false;
                      var coverageIsCurrent = false;
                        for (var i = 0; i < theProducts.length; i++) {
                            var p = theProducts[i];
                            lobIsHmo = ((p.lob == 'HMO') && (true)) ? true : lobIsHmo;
                            var milliServerDate = Date.parse($scope.serverDate);
                            coverageIsCurrent = (Date.parse(p.coverageEndDate) > milliServerDate ) ? true : coverageIsCurrent;  // 12/31/2014
                        }
                        hasHmo = lobIsHmo && coverageIsCurrent;
                        return hasHmo;
                    },
                    loadTeleMedicineTeamsiteContent: function(){
                    //Loading vendor name from UMS
                        var teleMedicineVendorName = "DEFAULT";
                        var currentPlans = this.getCurrentProducts();
                        var brand = btsGlobal.config.brand.umsBrandCode || btsGlobal.config.brand.sharedBrandCode;


                        djArray.forEach(currentPlans, function (item) {
                            if (item.telemedicineVendorName != null && item.telemedicineVendorName) {
                                teleMedicineVendorName = item.telemedicineVendorName.replace(/\s+/g, '').replace("&", "_");
                            }
                        });

                        if (brand && brand.toLowerCase() === 'mincr') {
                            teleMedicineVendorName = ((teleMedicineVendorName && teleMedicineVendorName.toUpperCase() === 'YES') ? teleMedicineVendorName = "OnlineCareAnywhere" : "DEFAULT");
                        }

                        var pennStatePortalClients = "069151,223885,240156";
                        var cnBasedContent = (pennStatePortalClients.indexOf($scope.currentMember.clientNumber) < 0) ? "": "_PSHOD";
                        //generate Telemedicine vendor key.
                        teleMedicineVendorKey = "MBR_TELEMEDICINE_PROVIDER_" + teleMedicineVendorName.toUpperCase() + cnBasedContent;
                        allinaGroupsKey = "SUPRESS_ONLINECARE_GROUPS";

                        $scope.teleMedicineVendorKey = teleMedicineVendorKey;

                        return aemContent.getAEMJsonContent().then(function(data) {
                            var x = {};
                            x[teleMedicineVendorKey] = aemContent.getContentValue(data[teleMedicineVendorKey]);
                            x[allinaGroupsKey] = aemContent.getContentValue(data[allinaGroupsKey]);
                            return x;
                        });
                    },
                    getTeamsiteContent: function() {
                        return aemContent.getAEMJsonContent().then(function(data) {
                            return {
                                //PCP POR
                                'MBR_MGRLANDING_ALERTS_POR': aemContent.getContentValue(data['MBR_MGRLANDING_ALERTS_POR']),
                                'MBR_MBRLANDING_ALERTS_PCP': aemContent.getContentValue(data['MBR_MBRLANDING_ALERTS_PCP']),
                                'LANDING_PCP_POR_DUMMY_CODES': aemContent.getContentValue(data['LANDING_PCP_POR_DUMMY_CODES']),
                                'MBR_MBRHOME_BANNER_PRE_EFFECTUATED_TITLE': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_PRE_EFFECTUATED_TITLE']),
                                'MBR_MBRHOME_BANNER_PRE_EFFECTUATED_DESCRIPTION': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_PRE_EFFECTUATED_DESCRIPTION']),
                                'MBR_MBRHOME_BANNER_PRE_EFFECTUATED_RIBBON_ITEMS': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_PRE_EFFECTUATED_RIBBON_ITEMS']),
                                'MBR_MBRHOME_BANNER_FORMS_LIBRARY_TITLE': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_FORMS_LIBRARY_TITLE']),
                                'MBR_MBRHOME_BANNER_FORMS_LIBRARY_TITLE_ND': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_FORMS_LIBRARY_TITLE_ND']),
                                'MBR_MBRHOME_BANNER_FORMS_LIBRARY_DESCRIPTION': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_FORMS_LIBRARY_DESCRIPTION']),
                                'MBR_MBRHOME_BANNER_FORMS_LIBRARY_DESCRIPTION_ND': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_FORMS_LIBRARY_DESCRIPTION_ND']),
                                'MBR_MBRHOME_BANNER_BENEFIT_SEARCH_TITLE': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_BENEFIT_SEARCH_TITLE']),
                                'MBR_MBRHOME_ALERTS_SPENDING_OUTAGE': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SPENDING_OUTAGE']),
                                'MBR_MBRHOME_ALERTS_SPENDING_OUTAGE_2': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SPENDING_OUTAGE_2']),
                                'MBR_MBRHOME_ALERTS_SPENDING_OUTAGE_AFTER_EFFECTIVE': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SPENDING_OUTAGE_AFTER_EFFECTIVE']),
                                'MBR_MBRHOME_ALERTS_SPENDING_OUTAGE_AFTER_EFFECTIVE_2': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SPENDING_OUTAGE_AFTER_EFFECTIVE_2']),
                                'MBR_MBRHOME_ALERTS_SERVICE_DOWN': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SERVICE_DOWN']),
                                'MBR_MBRHOME_ALERTS_SERVICE_DOWN_SABLACKOUT': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SERVICE_DOWN_SABLACKOUT']),
                                'MBR_MBRHOME_SMART_MESSAGE': aemContent.getContentValue(data['MBR_MBRHOME_SMART_MESSAGE']),
                                'MBR_MBRHOME_BANNER_CMS_TITLE': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_CMS_TITLE']),
                                'MBR_MBRHOME_BANNER_CMS_DESCRIPTION': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_CMS_DESCRIPTION']),
                                'MBR_MBRHOME_BANNER_CMS_LINK_ACA': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_CMS_LINK_ACA']),
                                'MBR_MBRHOME_BANNER_CMS_LINK_TAX': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_CMS_LINK_TAX']),
                                'MBR_MBRHOME_HEALTHTOOLS_TITLE': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_TITLE']),
                                'MBR_MBRHOME_HEALTHTOOLS_DESCRIPTION': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_DESCRIPTION']),
                                'MBR_MBRHOME_HEALTHTOOLS_SMARTSHOPPER_LABEL': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_SMARTSHOPPER_LABEL']),
                                'MBR_MBRHOME_HEALTHTOOLS_FORMS_LIBRARY': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_FORMS_LIBRARY']),
                                'MBR_MBRHOME_HEALTHTOOLS_BENEFIT_SEARCH': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_BENEFIT_SEARCH']),
                                'MBR_MBRHOME_HEALTHTOOLS_CASTLIGHT_LINK': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_CASTLIGHT_LINK']),
                                'MBR_MBRHOME_HEALTHTOOLS_COMPCOST_LINK': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_COMPCOST_LINK']),
                                'MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK']),
                                'MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK_MINCR': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK_MINCR']),
                                'MBR_MBRHOME_VITALS_MODAL': aemContent.getContentValue(data['MBR_MBRHOME_VITALS_MODAL']),
                                'MBR_MBRHOME_HEALTHTOOLS_PROVIDER_LINK': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_PROVIDER_LINK']),
                                'MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_REGISTERED': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_REGISTERED']),
                                'MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_UNREGISTERED': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_UNREGISTERED']),
                                'MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_REGISTERED_NEW': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_REGISTERED_NEW']),
                                'MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_UNREGISTERED_NEW': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_UNREGISTERED_NEW']),
                                'MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_EBILL': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_EBILL']),
                                'MBR_MBRHOME_HEALTHTOOLS_MYCHART_LINK': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_MYCHART_LINK']),
                                'MBR_MBRHOME_HEALTHTOOLS_PROVIDER_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_PROVIDER_LINK_HREF']),
                                'MBR_MBRHOME_HEALTHTOOLS_CASTLIGHT_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_CASTLIGHT_LINK_HREF']),
                                'MBR_MBRHOME_HEALTHTOOLS_COMPCOST_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_COMPCOST_LINK_HREF']),
                                'MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK_HREF']),
                                'MBR_MBRHOME_HEALTHTOOLS_MYCHART_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_MYCHART_LINK_HREF']),
                                'MBR_MBRHOME_FORMS_LIBRARY_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_FORMS_LIBRARY_LINK_HREF']),
                                'MBR_MBRHOME_FORMS_LIBRARY_LINK_HREF_ND': aemContent.getContentValue(data['MBR_MBRHOME_FORMS_LIBRARY_LINK_HREF_ND']),
                                'MBR_MBRHOME_BENEFIT_SEARCH_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_BENEFIT_SEARCH_LINK_HREF']),
                                'MBR_MBRHOME_HEALTHTOOLS_BENEFIT_SEARCH_LINK': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_BENEFIT_SEARCH_LINK']),
                                'MBR_GLOBAL_WELLTOK_GROUPS': aemContent.getContentValue(data['MBR_GLOBAL_WELLTOK_GROUPS']),
                                'MBR_MBRHOME_PROGRAMS_TITLE': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_TITLE']),
                                'MBR_MBRHOME_PROGRAMS_SHARECARE_TITLE': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_SHARECARE_TITLE']),
                                'MBR_MBRHOME_SHARECARE_PROGRAMS_DESCRIPTION': aemContent.getContentValue(data['MBR_MBRHOME_SHARECARE_PROGRAMS_DESCRIPTION']),
                                'MBR_MBRHOME_PROGRAMS_DESCRIPTION': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_DESCRIPTION']),
                                'MBR_MBRHOME_PROGRAMS_TITLE_NDBCBS': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_TITLE_NDBCBS']),
                                'MBR_MBRHOME_PROGRAMS_DESCRIPTION_NDBCBS': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_DESCRIPTION_NDBCBS']),
                                'MBR_MBRHOME_PROGRAMS_TITLE_WYBCBS': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_TITLE_WYBCBS']),
                                'MBR_MBRHOME_PROGRAMS_DESCRIPTION_WYBCBS': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_DESCRIPTION_WYBCBS']),
                                'MBR_MBRHOME_PROGRAMS_DISCOUNTS': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_DISCOUNTS']),
                                'MBR_MBRHOME_PROGRAMS_DISCOUNTS_HREF': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_DISCOUNTS_HREF']),
                                'MBR_MBRHOME_PROGRAMS_WELLPROFILE': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_WELLPROFILE']),
                                'MBR_MBRHOME_PROGRAMS_WELLPROFILE_HREF': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_WELLPROFILE_HREF']),
                                'MBR_MBRHOME_PROGRAMS_WELLPROFILE_SCORE': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_WELLPROFILE_SCORE']),
                                'MBR_MBRHOME_PROGRAMS_REWARDS': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_REWARDS']),
                                'MBR_MBRHOME_PROGRAMS_REWARDS_HREF': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_REWARDS_HREF']),
                                'MBR_MBRHOME_PROGRAMS_WELLTOK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_WELLTOK_HREF']),
                                'MBR_MBRHOME_PROGRAMS_WELLCHALLENGES': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_WELLCHALLENGES']),
                                'MBR_MBRHOME_PROGRAMS_WELLCHALLENGES_HREF': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_WELLCHALLENGES_HREF']),
                                'MBR_MBRHOME_PROGRAMS_VALBASED_SIGNUP': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_VALBASED_SIGNUP']),
                                'MBR_MBRHOME_PROGRAMS_VALBASED_SIGNUP_HREF': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_VALBASED_SIGNUP_HREF']),
                                'MBR_MBRHOME_PROGRAMS_VALBASED': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_VALBASED']),
                                'MBR_MBRHOME_PROGRAMS_VALBASED_LINK': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_VALBASED_LINK']),
                                'MBR_MBRHOME_MODALTITLE_PAYPREMIUM': aemContent.getContentValue(data['MBR_MBRHOME_MODALTITLE_PAYPREMIUM']),
                                'MBR_MBRHOME_MODAL_PAYPREMIUM': aemContent.getContentValue(data['MBR_MBRHOME_MODAL_PAYPREMIUM']),
                                'MBR_MBRHOME_MODALTITLE_PROCESSING_LTDACCESS': aemContent.getContentValue(data['MBR_MBRHOME_MODALTITLE_PROCESSING_LTDACCESS']),
                                'MBR_MBRHOME_MODAL_PROCESSING_LTDACCESS': aemContent.getContentValue(data['MBR_MBRHOME_MODAL_PROCESSING_LTDACCESS']),
                                'MBR_MBRHOME_MODALTITLE_DEPENDENT_LTDACCESS': aemContent.getContentValue(data['MBR_MBRHOME_MODALTITLE_DEPENDENT_LTDACCESS']),
                                'MBR_MBRHOME_MODAL_DEPENDENT_LTDACCESS': aemContent.getContentValue(data['MBR_MBRHOME_MODAL_DEPENDENT_LTDACCESS']),
                                'MBR_MBRHOME_MODALTITLE_WAYSTOPAY': aemContent.getContentValue(data['MBR_MBRHOME_MODALTITLE_WAYSTOPAY']),
                                'MBR_MBRHOME_MODAL _WAYSTOPAY': aemContent.getContentValue(data['MBR_MBRHOME_MODAL _WAYSTOPAY']),
                                'MBR_MBRHOME_MODAL _WAYSTOPAY_ONLINE': aemContent.getContentValue(data['MBR_MBRHOME_MODAL _WAYSTOPAY_ONLINE']),
                                'MBR_MBRHOME_MODAL _WAYSTOPAY_PHONE': aemContent.getContentValue(data['MBR_MBRHOME_MODAL _WAYSTOPAY_PHONE']),
                                'MBR_MBRHOME_MODAL _WAYSTOPAY_PRNTMAIL': aemContent.getContentValue(data['MBR_MBRHOME_MODAL _WAYSTOPAY_PRNTMAIL']),
                                'MBR_MBRHOME_MODAL_PREEFFECTIVE_LTDACCESS': aemContent.getContentValue(data['MBR_MBRHOME_MODAL_PREEFFECTIVE_LTDACCESS']),
                                'MBR_WELLNESS_PASSPORT_REWARDS_MODAL': aemContent.getContentValue(data['MBR_WELLNESS_PASSPORT_REWARDS_MODAL']),
                                'SHARECARE_SOFTLAUNCH_GROUPS': aemContent.getContentValue(data['SHARECARE_SOFTLAUNCH_GROUPS']),
                                'SHARECARE_SOFTLAUNCH_GROUPS_MN': aemContent.getContentValue(data['SHARECARE_SOFTLAUNCH_GROUPS_MN']),
                                'MBR_WELLNESS_SHARECARE_LINK': aemContent.getContentValue(data['MBR_WELLNESS_SHARECARE_LINK']),
                                'MBR_WELLNESS_SHARECARE_LINK_TEST': aemContent.getContentValue(data['MBR_WELLNESS_SHARECARE_LINK_TEST']),
                                'MBR_MBRHOME_ESPOTS_MINCR': aemContent.getContentValue(data['MBR_MBRHOME_ESPOTS_MINCR']),
                                'MBR_MBRHOME_ESPOT_IDTHEFT_SRC': aemContent.getContentValue(data['MBR_MBRHOME_ESPOT_IDTHEFT_SRC']),
                                'MBR_MBRHOME_ESPOT_IDTHEFT_TARGET': aemContent.getContentValue(data['MBR_MBRHOME_ESPOT_IDTHEFT_TARGET']),
                                'MBR_MBRHOME_ESPOT_MYCARENAVIGATOR_SRC': aemContent.getContentValue(data['MBR_MBRHOME_ESPOT_MYCARENAVIGATOR_SRC']),
                                'MBR_MBRHOME_ESPOT_MYCARENAVIGATOR_TEXT': aemContent.getContentValue(data['MBR_MBRHOME_ESPOT_MYCARENAVIGATOR_TEXT']),
                                'MBR_MBRHOME_ESPOT_MYCARENAVIGATOR_TARGET': aemContent.getContentValue(data['MBR_MBRHOME_ESPOT_MYCARENAVIGATOR_TARGET']),
                                'MER_MBRINFO_GRPPEND': aemContent.getContentValue(data['MER_MBRINFO_GRPPEND']),
                                'MER_MBRINFO_GRPREADY': aemContent.getContentValue(data['MER_MBRINFO_GRPREADY']),
                                'MER_MBRINFO_COVINACTIVE': aemContent.getContentValue(data['MER_MBRINFO_COVINACTIVE']),
                                'MER_MBRINFO_FUTURE': aemContent.getContentValue(data['MER_MBRINFO_FUTURE']),
                                'MER_MBRINFO_NOPAY': aemContent.getContentValue(data['MER_MBRINFO_NOPAY']),
                                'MER_MBRINFO_CANCELLED': aemContent.getContentValue(data['MER_MBRINFO_CANCELLED']),
                                'MBR_MBRHOME_COVCANMODALTTL': aemContent.getContentValue(data['MBR_MBRHOME_COVCANMODALTTL']),
                                'MBR_MBRHOME_COVCANMODALTXT': aemContent.getContentValue(data['MBR_MBRHOME_COVCANMODALTXT']),
                                'MER_MBRINFO_FUTURE_IBCCR': aemContent.getContentValue(data['MER_MBRINFO_FUTURE_IBCCR']),
                                'MER_MBRINFO_FUTURE_IBCAH': aemContent.getContentValue(data['MER_MBRINFO_FUTURE_IBCAH']),
                                'MBR_MBRHOME_ALERTS_HSA': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_HSA']),
                                'MBR_MBRHOME_ALERTS_HSA_LINK': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_HSA_LINK']),
                                'MBR_MBRHOME_ALERTS_HSA_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_HSA_LINK_HREF']),
                                'MBR_MBRHOME_ALERTS_CLAIMS': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_CLAIMS']),
                                'MBR_MBRHOME_ALERTS_CLAIMS_1': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_CLAIMS_1']),
                                'MBR_MBRHOME_ALERTS_CLAIMS_LINK': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_CLAIMS_LINK']),
                                'MBR_MBRHOME_ALERTS_SPENDING': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SPENDING']),
                                'MBR_MBRHOME_ALERTS_SPENDING_1': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SPENDING_1']),
                                'MBR_MBRHOME_ALERTS_SPENDING_LINK': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SPENDING_LINK']),
                                'MBR_MBRHOME_ALERTS_SPENDING_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SPENDING_LINK_HREF']),
                                'MBR_MBRHOME_ALERTS_PRIORAUTH': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_PRIORAUTH']),
                                'MBR_MBRHOME_ALERTS_PRIORAUTH_HREF': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_PRIORAUTH_HREF']),
                                'MBR_MBRHOME_ALERTS_PRIORAUTH_LINK': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_PRIORAUTH_LINK']),
                                'MBR_MBRHOME_ALERTS_EMAIL': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_EMAIL']),
                                'MBR_MBRHOME_ALERTS_EMAIL_LINK': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_EMAIL_LINK']),
                                'MBR_MBRHOME_ALERTS_EMAIL_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_EMAIL_LINK_HREF']),
                                'MBR_MBRHOME_ALERTS_PAPERLESS': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_PAPERLESS']),
                                'MBR_MBRHOME_ALERTS_PAPERLESS_1': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_PAPERLESS_1']),
                                'MBR_MBRHOME_ALERTS_PAPERLESS_LINK': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_PAPERLESS_LINK']),
                                'MBR_MBRHOME_ALERTS_PAPERLESS_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_PAPERLESS_LINK_HREF']),
                                'MBR_MBRHOME_TOPHEADER_CATEGORYTITLE': aemContent.getContentValue(data['MBR_MBRHOME_TOPHEADER_CATEGORYTITLE']),
                                'MBR_MBRHOME_RIBBON_MEMINFO': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_MEMINFO']),
                                'MBR_MBRHOME_RIBBON_MEMID': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_MEMID']),
                                'MBR_MBRHOME_RIBBON_GROUPNUM': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_GROUPNUM']),
                                'MBR_MBRHOME_RIBBON_OTHERMEMINFO': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_OTHERMEMINFO']),
                                'MBR_MBRHOME_RIBBON_OTHERMEMINFO_NDBCBS': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_OTHERMEMINFO_NDBCBS']),
                                'MBR_MBRHOME_RIBBON_OTHERMEMINFO_HREF': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_OTHERMEMINFO_HREF']),
                                'MBR_MBRHOME_RIBBON_IDCARD': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_IDCARD']),
                                'MBR_MBRHOME_RIBBON_IDCARD_HREF': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_IDCARD_HREF']),
                                'MBR_MBRHOME_RIBBON_CVGSUM': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_CVGSUM']),
                                'MBR_MBRHOME_RIBBON_CVGSUM_HREF': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_CVGSUM_HREF']),
                                'MBR_MBRHOME_MSGCNTR_HREF': aemContent.getContentValue(data['MBR_MBRHOME_MSGCNTR_HREF']),
                                'MBR_MBRHOME_REVIEW_MSGS': aemContent.getContentValue(data['MBR_MBRHOME_REVIEW_MSGS']),
                                'MBR_MBRHOME_NEW_MSGS': aemContent.getContentValue(data['MBR_MBRHOME_NEW_MSGS']),
                                'MBR_MBRHOME_CHOOSE_YOUR_PCP_MODAL': aemContent.getContentValue(data['MBR_MBRHOME_CHOOSE_YOUR_PCP_MODAL']),
                                'MBR_MBRHOME_RIBBON_BB': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_BB']),
                                'MER_BENEFITBOOKLET_ERROR': aemContent.getContentValue(data['MER_BENEFITBOOKLET_ERROR']),
                                'MBR_BENEFITBOOKLET_LANDINGPAGE_ERROR': aemContent.getContentValue(data['MBR_BENEFITBOOKLET_LANDINGPAGE_ERROR']),
                                'MBR_BENEFITBOOKLET_QUALTRICS_LINK': aemContent.getContentValue(data['MBR_BENEFITBOOKLET_QUALTRICS_LINK']),
                                'MBR_BENEFITBOOKLET_LANDINGPAGE_ERROR_CODE': aemContent.getContentValue(data['MBR_BENEFITBOOKLET_LANDINGPAGE_ERROR_CODE']),
                                'FORMS_LIBRARY_NOT_ENTITLED_MODAL_CONTENT': aemContent.getContentValue(data['FORMS_LIBRARY_NOT_ENTITLED_MODAL_CONTENT']),
                                'FORMS_LIBRARY_NOT_ENTITLED_MODAL_TITLE': aemContent.getContentValue(data['FORMS_LIBRARY_NOT_ENTITLED_MODAL_TITLE']),
                                'MBR_MBRHOME_COVERAGE_SUMMARYTTIP': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_SUMMARYTTIP']),
                                'MBR_MBRHOME_COVERAGE_SUMMARYTTIP_HREF': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_SUMMARYTTIP_HREF']),
                                'MBR_MBRHOME_COVERAGE_DEDUCTIBLE': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_DEDUCTIBLE']),
                                'MBR_MBRHOME_COVERAGE_COPAYS': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_COPAYS']),
                                'MBR_MBRHOME_COVERAGE_COINSURANCE': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_COINSURANCE']),
                                'MBR_MBRHOME_COVERAGE_OOPMAX': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_OOPMAX']),
                                'MBR_MBRHOME_COVERAGE_FAMDEDUCTIBLE': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_FAMDEDUCTIBLE']),
                                'MBR_MBRHOME_COVERAGE_HOMEHOST_TIERHEADER': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_HOMEHOST_TIERHEADER']),
                                'MBR_MBRHOME_COVERAGE_HOMEHOST_REGION_TIERHEADER': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_HOMEHOST_REGION_TIERHEADER']),
                                'MBR_MBRHOME_COVERAGE_HOMEHOST__REGION_TIERHEADER': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_HOMEHOST__REGION_TIERHEADER']),
                                'MER_COVERAGE_SUMMARY_CSGRID_HOMEHOST_REGION_VALUE_HDR': aemContent.getContentValue(data['MER_COVERAGE_SUMMARY_CSGRID_HOMEHOST_REGION_VALUE_HDR']),
                                'MBR_MBRHOME_COVERAGE_TIERHEADER': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_TIERHEADER']),
                                'MBR_MBRHOME_COVERAGE_TIERHEADERFOUR': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_TIERHEADERFOUR']),
                                'MBR_MBRHOME_COVERAGE_TIERHEADERNONE': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_TIERHEADERNONE']),
                                'MBR_MBRHOME_COVERAGE_TIERHEADERTHREE': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_TIERHEADERTHREE']),
                                'MBR_MBRHOME_FINDOCTORPROMO_TITILE': aemContent.getContentValue(data['MBR_MBRHOME_FINDOCTORPROMO_TITILE']),
                                'MBR_MBRHOME_FINDOCTORPROMO_SUBTITILE': aemContent.getContentValue(data['MBR_MBRHOME_FINDOCTORPROMO_SUBTITILE']),
                                'MBR_MBRHOME_FINDOCTORPROMO_TEXT': aemContent.getContentValue(data['MBR_MBRHOME_FINDOCTORPROMO_TEXT']),
                                'MBR_MBRHOME_FINDOCTORPROMO_SEARCHLINK': aemContent.getContentValue(data['MBR_MBRHOME_FINDOCTORPROMO_SEARCHLINK']),
                                'MBR_LANDING_GUIDEWELL_MEDICARE_HEADING': aemContent.getContentValue(data['MBR_LANDING_GUIDEWELL_MEDICARE_HEADING']),
                                'MBR_LANDING_GUIDEWELL_MEDICARE_DESC': aemContent.getContentValue(data['MBR_LANDING_GUIDEWELL_MEDICARE_DESC']),
                                'MBR_LANDING_GUIDEWELL_MEDICARE_SMALLDESC': aemContent.getContentValue(data['MBR_LANDING_GUIDEWELL_MEDICARE_SMALLDESC']),
                                'MBR_LANDING_GUIDEWELL_MEDICARE_BUTTON': aemContent.getContentValue(data['MBR_LANDING_GUIDEWELL_MEDICARE_BUTTON']),
                                'MBR_LANDING_GUIDEWELL_HOME_HEADING': aemContent.getContentValue(data['MBR_LANDING_GUIDEWELL_HOME_HEADING']),
                                'MBR_LANDING_GUIDEWELL_HOME_DESC': aemContent.getContentValue(data['MBR_LANDING_GUIDEWELL_HOME_DESC']),
                                'MBR_LANDING_GUIDEWELL_HOME_BUTTON': aemContent.getContentValue(data['MBR_LANDING_GUIDEWELL_HOME_BUTTON']),
                                'SHOW_GUIDEWELL_UI_INDICATOR': aemContent.getContentValue(data['SHOW_GUIDEWELL_UI_INDICATOR']),
                                'MBR_BENEFIT_BOOKLET_SHOWBANNER_LADINGCOVERAGE_PAGE': aemContent.getContentValue(data['MBR_BENEFIT_BOOKLET_SHOWBANNER_LADINGCOVERAGE_PAGE']),




                                'MBR_MBRHOME_HEALTHTOOLS_RX_LINK': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_RX_LINK']),
                                'MBR_MBRHOME_WELLNESS_PROGRAMS_LINK1': aemContent.getContentValue(data['MBR_MBRHOME_WELLNESS_PROGRAMS_LINK1']),
                                'MBR_MBRHOME_WELLNESS_PROGRAMS_LINK1_IMG': aemContent.getContentValue(data['MBR_MBRHOME_WELLNESS_PROGRAMS_LINK1_IMG']),
                                'MBR_MBRHOME_WELLNESS_PROGRAMS_LINK2': aemContent.getContentValue(data['MBR_MBRHOME_WELLNESS_PROGRAMS_LINK2']),
                                'MBR_MBRHOME_WELLNESS_PROGRAMS_LINK2_IMG': aemContent.getContentValue(data['MBR_MBRHOME_WELLNESS_PROGRAMS_LINK2_IMG']),
                                'MBR_MBRHOME_WELLNESS_PROGRAMS_LINK3': aemContent.getContentValue(data['MBR_MBRHOME_WELLNESS_PROGRAMS_LINK3']),
                                'MBR_MBRHOME_WELLNESS_PROGRAMS_LINK3_IMG': aemContent.getContentValue(data['MBR_MBRHOME_WELLNESS_PROGRAMS_LINK3_IMG']),
                                'MBR_MBRHOME_HEALTH_TOOLS_LINK1': aemContent.getContentValue(data['MBR_MBRHOME_HEALTH_TOOLS_LINK1']),
                                'MBR_MBRHOME_HEALTH_TOOLS_LINK1_IMG': aemContent.getContentValue(data['MBR_MBRHOME_HEALTH_TOOLS_LINK1_IMG']),
                                'MBR_MBRHOME_HEALTH_TOOLS_LINK2': aemContent.getContentValue(data['MBR_MBRHOME_HEALTH_TOOLS_LINK2']),
                                'MBR_MBRHOME_HEALTH_TOOLS_LINK2_IMG': aemContent.getContentValue(data['MBR_MBRHOME_HEALTH_TOOLS_LINK2_IMG']),
                                'MBR_MBRHOME_HEALTH_TOOLS_LINK3': aemContent.getContentValue(data['MBR_MBRHOME_HEALTH_TOOLS_LINK3']),
                                'MBR_MBRHOME_HEALTH_TOOLS_LINK3_IMG': aemContent.getContentValue(data['MBR_MBRHOME_HEALTH_TOOLS_LINK3_IMG'])

                            };
                        });
                    },
                    preRender: function() {
                        this.myInit();
                        var serviceCalls = [];
                        serviceCalls.push(services.rbsmbl.memberInfo().fetch());
                        serviceCalls.push(this.getTeamsiteContent());
                        serviceCalls.push(services.rbsmbl.preEffectuatedService().fetch());

                        all(serviceCalls).then(lang.hitch(this, function (responses) {
                            // var acctSettings = responses[3].data.payload;
                            var theMemberInfo = responses[0].data.payload;

                            //pre effectuated flag
                            $scope.toolsPreEffectuated = responses[2].data.payload;

                            var serverDate = new Date();
                            var ums = new umsParse(theMemberInfo, serverDate);
                            $scope.serverDate = serverDate;
                            $scope.tsResponse = responses[1];
                            // $scope.qualifiedTeamsiteContent = this.self.page.model.QualifiedTeamsiteContent;
                            $scope.qualifiedTeamsiteContent = responses[1];
                            // $scope.clientGroupProductQualifiedTSContent = this.self.page.model.clientGroupProductQualifiedTSContent;
                            $scope.clientGroupProductQualifiedTSContent = responses[1];
                            $scope.currentMember = ums.currentMember();
                            $scope.baseInformation = ums.baseInformation();
                            $scope.userName = theMemberInfo.userName;
                            var portalSelectedPlan = ums.getPortalSelectedPlan();
                                portalSelectedPlan = portalSelectedPlan && portalSelectedPlan[0];
                            $scope.portalSelectedPlan = portalSelectedPlan;
                            // $scope.memberQualifiers = this.self.page.model.memberQualifiers;
                            $scope.memberQualifiers = $q.defer().promise;

                            var serviceCalls2 = [this.loadTeleMedicineTeamsiteContent()];
                            all(serviceCalls2).then(lang.hitch(this, function (response2) {
                                var tsResponse= response2[0];
                                if(teleMedicineVendorKey in tsResponse){
                                    teleMedicineTSContent = JSON.parse(tsResponse[teleMedicineVendorKey] || JSON.stringify({link: "Virtual Medicine"}));

                                    if($scope.currentMember.clientNumber === "255721"){
                                        teleMedicineTSContent.link = "TELEDOC"
                                        $scope.tsTelemedicine = teleMedicineTSContent.link;
                                    }else{
                                    $scope.tsTelemedicine = teleMedicineTSContent.link;
                                    }

                                    if ((btsGlobal.config.brand.sharedBrandCode == "mincr")) {
                                        var arrGrps = tsResponse['SUPRESS_ONLINECARE_GROUPS'].replace(/\s/g, '').split(",");
                                        $scope.showTelemedicine = (arrGrps.indexOf(portalSelectedPlan.groupNumber) == -1) ;
                                    }
                                    else {
                                        $scope.showTelemedicine = true ;
                                    }
                                }
                                else {
                                    $scope.showTelemedicine = false ;
                                }

                                //need to push into model...
                                this.populateModel($scope, portalSelectedPlan);
                            }));
                        }));
                    }
                };

                function dojoConvert() { 
                    return toMerge;
                };
                var d = new dojoConvert();
                d.preRender();


                } // END CONTROLLER FUNCTION
            ] // END CONTROLLER
        };
    });
    
}